// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `td, th {
   border: 1px solid #ddd;
   padding: 8px;
 }
`, "",{"version":3,"sources":["webpack://./src/table_report.css"],"names":[],"mappings":"AAAA;GACG,sBAAsB;GACtB,YAAY;CACd","sourcesContent":["td, th {\n   border: 1px solid #ddd;\n   padding: 8px;\n }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
